<template>
  <md-dropdown ref="dropdown" class="service" trigger="click" :hide-on-click="false" @visible-change="visibleChange">
    <div class="dropdown-title">
      <img src="@/assets/icon_switch.png" class="dropdown-img" alt="切换平台" />
      <span class="dropdown-text">切换平台</span>
      <!-- <span>{{ text }}</span> -->
    </div>
    <template #dropdown>
      <md-dropdown-menu class="app-list-switch">
        <md-input
          v-model="serachText"
          size="small"
          :prefix-icon="Search"
          clearable
          placeholder="搜索平台名称"
          class="serach-input"
          @keydown.stop
          @keyup.stop
        >
        </md-input>
        <div class="menu-container">
          <div v-if="copyAppList.length > 0">
            <a v-for="item in copyAppList" :key="item.applicationCode" @click="goCopyAppListPath(item, $event)">
              <md-dropdown-item name="system">
                <span>{{ item.applicationName }}</span>
                <span class="user-star-system" @click.stop.prevent="handleStarSystem(item)">
                  <i :class="isAppStarred(item) ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                </span>
              </md-dropdown-item>
            </a>
          </div>
          <div v-else class="no-data">
            <div class="no-data-icon"></div>
            <span>暂无搜索结果</span>
          </div>
        </div>
      </md-dropdown-menu>
    </template>
  </md-dropdown>
</template>
<script setup lang="ts">
import { computed, nextTick, onMounted, ref } from 'vue';
import { MdDropdown, MdDropdownItem, MdDropdownMenu, MdInput } from 'mdesign3';
import { useStore } from 'vuex';
import config from '@/config/user.env';
// @ts-ignore - legacy js util (no d.ts)
import { MdMessage } from 'mdesign3';
import { Search } from '@mdesign3/icons-vue';
// @ts-ignore - legacy js api (no d.ts)
import { getUserPlatformApps, deleteUserPlatformApps, getUserPlatformAppsList } from './api.js';

const dropdown = ref<any>(null);
const serachText = ref('');
const starredList = ref<any[]>([]);

const store = useStore();
const appList = computed<any[]>(() => (store.getters as any)['appList'] || []);

const isAppStarred = (item: any) => {
  return starredList.value.find((i) => i.applicationCode === item.applicationCode);
};

const copyAppList = computed(() => {
  let list: any[] = [];
  if (serachText.value) {
    list = appList.value.filter((item) => {
      return (item.applicationName || '').toUpperCase().includes(serachText.value.toUpperCase());
    });
  } else {
    list = appList.value;
  }

  const notStarred = list.filter((i) => !starredList.value.find((ii) => ii.applicationCode === i.applicationCode));
  return starredList.value
    .map((i) => list.find((item) => item.applicationCode === i.applicationCode))
    .filter(Boolean)
    .concat(notStarred);
});

const _text = computed(() => {
  const currentPath = appList.value.find((item) => {
    if (item.applicationDomain && item.customDomain) {
      return (
        item.customDomain === window.location.hostname &&
        String(item.applicationDomain).indexOf(window.location.pathname) >= 0
      );
    }
    return false;
  });
  return currentPath?.applicationName || '';
});

const resortListByStarredInfo = async () => {
  const res = await getUserPlatformAppsList({ platformCode: (config as any).platformCode, userCode: '' });
  if (res?.data && Array.isArray(res.data.list)) {
    starredList.value = res.data.list;
  } else {
    starredList.value = [];
  }
};

const handleStarSystem = async (item: any) => {
  const starred = isAppStarred(item);
  if (starred) {
    await deleteUserPlatformApps({ id: starred.id });
  } else {
    await getUserPlatformApps({
      platformCode: (config as any).platformCode,
      applicationCode: item.applicationCode,
      sortNo: 2,
    });
    MdMessage.success('收藏成功');
  }
  await resortListByStarredInfo();
};

const removeDropdownKeydownHandlerIfPossible = async () => {
  await nextTick();
  // 兼容旧版 el-dropdown 的内部实现；如果组件库已升级，这段会自动兜底不报错
  try {
    const d = dropdown.value;
    d?.triggerElm?.removeEventListener?.('keydown', d?.handleTriggerKeyDown);
  } catch (e) {
    // ignore
  }
};

const visibleChange = async (flag: boolean) => {
  if (!flag) {
    serachText.value = '';
  } else {
    await removeDropdownKeydownHandlerIfPossible();
  }
};

const dealPathUrl = (application: string, getPathDomain: string) => {
  if (application.indexOf('//') > -1) {
    return application;
  } else if (application.charAt(0) !== '/') {
    return '//' + getPathDomain + '/' + application;
  } else {
    return '//' + getPathDomain + application;
  }
};

const openNewPath = (pathUrl: string, _target?: string) => {
  const el = document.createElement('a');
  document.body.appendChild(el);
  el.target = '_blank'; // 指定在新窗口打开
  el.href = pathUrl;
  el.click();
  document.body.removeChild(el);
};

const goCopyAppListPath = (item: any, e: MouseEvent) => {
  const env = config.env !== undefined ? String(config.env).toLowerCase() : 'sit';
  const isNotProd = env !== 'prod';
  const anGopath = isNotProd ? 'an-' + env + '.midea.com' : 'an.midea.com';
  const authGopath = isNotProd ? 'auth-' + env + '.midea.com' : 'auth.midea.com';
  const lcGopath = isNotProd ? 'l' + env + '.midea.com' : 'lc.midea.com';

  let pathUrl = '';
  const application = item.applicationDomain || '';
  const defaultUrl = dealPathUrl(application, lcGopath);

  if (item.customDomain) {
    if (String(item.customDomain).indexOf('//') > -1) {
      pathUrl = item.customDomain + application;
    } else {
      pathUrl = '//' + item.customDomain + application;
    }
  } else if (document.domain === anGopath || document.domain === authGopath) {
    pathUrl = dealPathUrl(application, document.domain);
  } else {
    pathUrl = defaultUrl;
  }

  // 按住 ctrl 时，需要重新打开一个页面（保留原逻辑的参数传递）
  openNewPath(pathUrl, e.ctrlKey ? undefined : item.applicationCode);
};

onMounted(async () => {
  await removeDropdownKeydownHandlerIfPossible();
  await resortListByStarredInfo();
});
</script>
<style lang="less" scoped>
.service {
  cursor: pointer;
  .dropdown-title {
    display: flex;
    align-items: center;
    color: #4e5969;
    .dropdown-img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
}

.recent-system {
  border-top: 1px solid #dcdfe6;
  padding: 0 12px;

  .recent-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    & > * {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.app-list-switch {
  .user-star-system {
    float: right;
    font-size: 19px;
    transform: translateY(1px);
  }
  .el-icon-star-on {
    color: #02b3b6;
    transform: scale(1.2);
  }
}

.app-list-switch {
  max-height: 400px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  .no-data {
    text-align: center;
    padding: 10px 0;
    color: #4e5969;
    font-size: 14px;
    .no-data-icon {
      width: 112px;
      height: 112px;
      background: url('@/assets/not_data.png') no-repeat center center;
      background-size: 100% 100%;
      margin: 0 auto;
    }
  }
  .menu-container {
    width: 300px;
    height: 100%;
    overflow: auto;
  }

  .serach-input {
    width: 280px;
    padding: 8px;
    :deep(.md-input__suffix) {
      top: 12px;
    }
    :deep(.md-input__prefix) {
      left: 24px;
      top: 12px;
    }
    :deep(.md-input__inner) {
      padding-left: 38px;
      border: none;
      border-radius: 4px;
      background: #f5f7fa;
    }
  }
}
</style>
